export default __webpack_public_path__ + "86cc64fca4d97a0800d673bb40662f3f.png";